import * as React from 'react';
import classnames from 'classnames';
import ExtendedPropTypes from '@insolus/prop-types';
import SidebarItem from './Item';
import SidebarDropdown from './Dropdown';

var Sidebar = function Sidebar(_ref) {
  var compact = _ref.compact,
      children = _ref.children;

  var _className = classnames('Sidebar', {
    'Sidebar--compact': compact
  });

  return React.createElement("div", {
    className: _className
  }, React.createElement("ul", {
    className: "Sidebar__menu"
  }, children));
};

Sidebar.defaultProps = {
  compact: false,
  children: undefined
};
Sidebar.Item = SidebarItem;
Sidebar.Dropdown = SidebarDropdown;
export default Sidebar;